import { t } from "i18next";
import { AutomationOperators, getKeyValueDropdownDataModel } from "../../shared/utils/constants";

export const FORMS = t('forms.forms');
export const NEW_FORM = t('forms.new-form');
export const GETTING_ALL_FORMS = t('forms.getting-all-forms');
export const FORM_HEADERS: string[] = ['name', ''];
export const FORM_ACTIONS: DropdownDataModel[] = getKeyValueDropdownDataModel([
  {key: t('forms.submit'), value: 'Submit'},
  {key: t('forms.move-to-next-form'), value: 'MoveToNextForm'},
  {key: t('forms.move-to-previous-form'),value: 'MoveToPreviousForm'},
  {key: t('forms.move-to-x-form'), value: 'MoveToXForm'}
]);
export const FORM_FILTER_OPERATOR = {
  default: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  text: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.contains"), value: AutomationOperators.Contains},
    {key: t("forms.operators.not-contains"), value: AutomationOperators.NotContains},
    {key: t("forms.operators.ends-with"), value: AutomationOperators.EndsWith},
    {key: t("forms.operators.starts-with"), value: AutomationOperators.StartsWith},
    {key: t("forms.operators.not-starts-with"), value: AutomationOperators.NotStartsWith}
  ]),
  date: getKeyValueDropdownDataModel([
    {key: t("forms.operators.earlier-than"), value: AutomationOperators.LessThan},
    {key: t("forms.operators.later-than"), value: AutomationOperators.GreaterThan},
    {key: t("forms.operators.earlier-than-equal-to"), value: AutomationOperators.LessThanEqualTo},
    {key: t("forms.operators.later-than-equal-to"), value: AutomationOperators.GreaterThanEqualTo},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  time: getKeyValueDropdownDataModel([
    {key: t("forms.operators.later-than"), value: AutomationOperators.GreaterThan},
    {key: t("forms.operators.earlier-than"), value: AutomationOperators.LessThan},
    {key: t("forms.operators.later-than-equal-to"), value: AutomationOperators.GreaterThanEqualTo},
    {key: t("forms.operators.earlier-than-equal-to"), value: AutomationOperators.LessThanEqualTo},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  number: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.greater-than"), value: AutomationOperators.GreaterThan},
    {key: t("forms.operators.less-than"), value: AutomationOperators.LessThan},
    {key: t("forms.operators.greater-than-equal-to"), value: AutomationOperators.GreaterThanEqualTo},
    {key: t("forms.operators.less-than-equal-to"), value: AutomationOperators.LessThanEqualTo},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  choiceset: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  toggle: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
  ]),
  user: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.email-contains"), value: AutomationOperators.Contains},
    {key: t("forms.operators.email-not-contains"), value: AutomationOperators.NotContains},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  comment: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.contains"), value: AutomationOperators.Contains},
    {key: t("forms.operators.not-contains"), value: AutomationOperators.NotContains},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  attachment: getKeyValueDropdownDataModel([
    {key: t("forms.operators.is-empty"), value: AutomationOperators.IsEmpty},
    {key: t("forms.operators.is-not-empty"), value: AutomationOperators.IsNotEmpty}
  ]),
  collaborator: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.includes"), value: AutomationOperators.Include},
    {key: t("forms.operators.not-includes"), value: AutomationOperators.NotInclude},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
  tag: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.contains"), value: AutomationOperators.Contains},
    {key: t("forms.operators.not-contains"), value: AutomationOperators.NotContains},
    {key: t("forms.operators.includes"), value: AutomationOperators.Include},
    {key: t("forms.operators.not-includes"), value: AutomationOperators.NotInclude},
  ]),
  affecteduser: getKeyValueDropdownDataModel([
    {key: t("forms.operators.equal"), value: AutomationOperators.Equal},
    {key: t("forms.operators.not-equal"), value: AutomationOperators.NotEqual},
    {key: t("forms.operators.email-contains"), value: AutomationOperators.Contains},
    {key: t("forms.operators.email-not-contains"), value: AutomationOperators.NotContains},
    {key: t("forms.operators.includes"), value: AutomationOperators.Include},
    {key: t("forms.operators.not-includes"), value: AutomationOperators.NotInclude},
    {key: t("forms.operators.is-null"), value: AutomationOperators.IsNull},
    {key: t("forms.operators.is-not-null"), value: AutomationOperators.IsNotNull}
  ]),
};

export const SEND_FORM_OPTION  = 
{
  SEND_TO_REQUESTER: 'send',
  SEND_TO_ASSIGNEE: 'sendFormToAssignee',
  SEND_TO_AFFECTEDUSER: 'sendFormToAffectedUser',
  SEND_TO_COLLABORATOR: 'sendFormToCollaborator',
  ANSWER_NOW: 'answer'
}